import styled from 'styled-components';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const FormLabel = styled.label``;

// [SW-654] Weird IE11 hack
// Had to split up the label properties in two
const FormInput = styled.input`
  &:focus ~ ${FormLabel}, &:not(:-ms-input-placeholder) ~ ${FormLabel} {
    top: -20px;
    font-size: 12px;
  }

  &:focus ~ ${FormLabel}, &:not(:placeholder-shown) ~ ${FormLabel} {
    top: -20px;
    font-size: 12px;
  }

  &:not(:placeholder-shown):invalid:required ~ ${FormLabel} {
    color: ${fullConfig.theme.extend.colors.notification.error};
  }

  &:not(:placeholder-shown):valid:required ~ ${FormLabel} {
    color: ${fullConfig.theme.extend.colors.notification.success};
  }
`;

export { FormInput, FormLabel };
